import React from 'react';
import { createStackNavigator } from '@react-navigation/stack';
import { ClubsStackParamList } from '../types/navigation';
import ClubsHomeScreen from '../screens/clubs/ClubsHomeScreen';
import ClubDetailScreen from '../screens/clubs/ClubDetailScreen';
import CreateClubScreen from '../screens/clubs/CreateClubScreen';
import EditClubScreen from '../screens/clubs/EditClubScreen';
import JoinClubFormScreen from '../screens/clubs/JoinClubFormScreen';
import EnterClubCodeScreen from '../screens/clubs/EnterClubCodeScreen';
import ClubChatScreen from '../screens/clubs/ClubChatScreen';
import ClubMembersScreen from '../screens/clubs/ClubMembersScreen';
import { SendMeetupScreen } from '../screens/clubs/SendMeetupScreen';
import { MeetupsListScreen } from '../screens/clubs/MeetupsListScreen';
import CreatePostScreen from '../screens/CreatePostScreen';
import CreateReferralScreen from '../screens/clubs/CreateReferralScreen';
import SubmitIntroScreen from '../screens/clubs/SubmitIntroScreen';
import ReferralRequestDetailScreen from '../screens/clubs/ReferralRequestDetailScreen';
import ClubPaymentScreen from '../screens/clubs/ClubPaymentScreen';

const Stack = createStackNavigator<ClubsStackParamList>();

const ClubsNavigator: React.FC = () => {
  return (
    <Stack.Navigator
      screenOptions={{
        headerShown: false,
      }}
    >
      <Stack.Screen name="ClubsHome" component={ClubsHomeScreen} />
      <Stack.Screen name="ClubDetail" component={ClubDetailScreen} />
      <Stack.Screen name="CreateClub" component={CreateClubScreen} />
      <Stack.Screen name="EditClub" component={EditClubScreen} />
      <Stack.Screen name="JoinClubForm" component={JoinClubFormScreen} />
      <Stack.Screen name="EnterClubCode" component={EnterClubCodeScreen} />
      <Stack.Screen name="ClubChat" component={ClubChatScreen} />
      <Stack.Screen name="ClubMembers" component={ClubMembersScreen} />
      <Stack.Screen name="SendMeetup" component={SendMeetupScreen} />
      <Stack.Screen name="MeetupsList" component={MeetupsListScreen} />
      <Stack.Screen name="CreatePost" component={CreatePostScreen} />
      <Stack.Screen name="CreateReferral" component={CreateReferralScreen} />
      <Stack.Screen name="SubmitIntro" component={SubmitIntroScreen} />
      <Stack.Screen name="ReferralRequestDetail" component={ReferralRequestDetailScreen} />
      <Stack.Screen name="ClubPayment" component={ClubPaymentScreen} />
    </Stack.Navigator>
  );
};

export default ClubsNavigator;
export type { ClubsStackParamList };
